import styled from 'styled-components';

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  user-select: none;
  border: ${(props) => (props.showBorder ? '1px solid #C9C6CC' : null)};
  padding: 6px 8px 6px 12px;
  border-radius: 27px;
`;

export const SwitchLabel = styled.span`
  margin-right: 10px;
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 400;
  font-size: var(--font-size-l);
  line-height: 24px;
  color: #000000;
`;
